exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".text-input-highlight-container{position:relative}.text-input-highlight-container .text-input-element{background:none;position:relative;z-index:2}.text-input-highlight-container .text-highlight-element{overflow:hidden!important;word-break:break-word;white-space:pre-wrap;position:absolute;top:0;bottom:0;left:0;right:0;background:#fff;color:transparent;z-index:1}.text-input-highlight-container .text-highlight-tag{border-radius:8px;padding:1px 3px;margin:-1px -3px;overflow-wrap:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/text-input-highlight.scss
// module id = 152
// module chunks = 0